import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipProgramActiveComponent } from './tip-program-active.component';
import { AddTipProgramActiveComponent } from './add-tip-program-active/add-tip-program-active.component';
import { EditTipProgramActiveComponent } from './edit-tip-program-active/edit-tip-program-active.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        TipProgramActiveComponent,
        AddTipProgramActiveComponent,
        EditTipProgramActiveComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TipProgramActiveComponent]
})
export class TipProgramActiveModule { }
